import React from "react";
import { COLORS, RADIUS, SHADOW } from "../../theme";

export default function Card({ style, children, ...props }) {
  return (
    <div
      style={{
        background: COLORS.surface,
        border: "1px solid rgba(228,233,242,0.7)",
        borderRadius: RADIUS.xl,
        boxShadow: SHADOW.float,
        padding: 20,
        ...style,
      }}
      {...props}
    >
      {children}
    </div>
  );
}
